"use client"

import { getNonUmbracoUrl } from "@/utils"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import { useTranslations } from "next-intl"
import React from "react"
import { iconsMap } from "../../public/icons/iconsMap"
import AccordionItem from "../common/bit/AccordionItem"
import ButtonWithArrow from "../common/bit/ButtonWithArrow"
import CommonTitle from "../common/bit/CommonTitle"
import { mediaQueries, sizes } from "../theme/theme"

interface ButtonLinkProps {
  url?: string
  name?: string
}

interface AccordionItemProps {
  title?: string
  button?: ButtonLinkProps
  itemsList: {
    question?: string
    answer?: string
    title?: string
    text?: string
  }[]
}

const StyledAccordionList = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  .MuiButton-root {
    margin-top: ${sizes.baseSix};
  }
`
const StyledItemsList = styled("ul")`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  padding: 0;
  margin: 0;
  gap: ${sizes.baseTriple};
`

const StyledAccordion = styled(AccordionItem)`
  && {
    &.MuiAccordion-root {
      width: 48%;
      ${mediaQueries.mobile} {
        width: 100%;
      }
      .MuiAccordionDetails-root {
        padding: 0;
      }
    }
  }
`

const AccordionItemsPlusIconList: React.FC<
  React.PropsWithChildren<AccordionItemProps>
> = ({ title, button, itemsList }) => {
  const PlusIcon = iconsMap["plus-element"]
  const MinusIcon = iconsMap["minus-element"]
  const t = useTranslations("AccordionItem")
  return (
    <StyledAccordionList>
      {title && <CommonTitle>{title}</CommonTitle>}
      <StyledItemsList>
        {itemsList &&
          itemsList.map((item, index: number) => {
            const { title, text, question, answer } = item
            return (
              <StyledAccordion
                key={`accordion-item-${title || question || index}-${index}`}
                title={question || title || ""}
                text={answer || text || ""}
                pretitle={t("whatDoesItMean")}
                openIcon={<PlusIcon />}
                closeIcon={<MinusIcon />}
              />
            )
          })}
      </StyledItemsList>
      {button && button.url && (
        <ButtonWithArrow href={getNonUmbracoUrl(button.url)}>
          {button.name}
        </ButtonWithArrow>
      )}
    </StyledAccordionList>
  )
}
export default AccordionItemsPlusIconList
